import _objectWithoutProperties from "/opt/build/repo/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/opt/build/repo/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/opt/build/repo/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["isDisabled", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// ../../../react-shim.js
import React from "react"; // src/tag.tsx

import { Icon } from "@chakra-ui/icon";
import { createContext } from "@chakra-ui/react-context";
import { chakra, forwardRef, omitThemingProps, useMultiStyleConfig } from "@chakra-ui/system";

var _createContext = createContext({
  name: "TagStylesContext",
  errorMessage: "useTagStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<Tag />\" "
}),
    _createContext2 = _slicedToArray(_createContext, 2),
    TagStylesProvider = _createContext2[0],
    useTagStyles = _createContext2[1];

var Tag = forwardRef(function (props, ref) {
  var styles = useMultiStyleConfig("Tag", props);
  var ownProps = omitThemingProps(props);

  var containerStyles = _objectSpread({
    display: "inline-flex",
    verticalAlign: "top",
    alignItems: "center",
    maxWidth: "100%"
  }, styles.container);

  return /* @__PURE__ */React.createElement(TagStylesProvider, {
    value: styles
  }, /* @__PURE__ */React.createElement(chakra.span, _objectSpread(_objectSpread({
    ref: ref
  }, ownProps), {}, {
    __css: containerStyles
  })));
});
Tag.displayName = "Tag";
var TagLabel = forwardRef(function (props, ref) {
  var styles = useTagStyles();
  return /* @__PURE__ */React.createElement(chakra.span, _objectSpread(_objectSpread({
    ref: ref,
    noOfLines: 1
  }, props), {}, {
    __css: styles.label
  }));
});
TagLabel.displayName = "TagLabel";
var TagLeftIcon = forwardRef(function (props, ref) {
  return /* @__PURE__ */React.createElement(Icon, _objectSpread({
    ref: ref,
    verticalAlign: "top",
    marginEnd: "0.5rem"
  }, props));
});
TagLeftIcon.displayName = "TagLeftIcon";
var TagRightIcon = forwardRef(function (props, ref) {
  return /* @__PURE__ */React.createElement(Icon, _objectSpread({
    ref: ref,
    verticalAlign: "top",
    marginStart: "0.5rem"
  }, props));
});
TagRightIcon.displayName = "TagRightIcon";

var TagCloseIcon = function TagCloseIcon(props) {
  return /* @__PURE__ */React.createElement(Icon, _objectSpread({
    verticalAlign: "inherit",
    viewBox: "0 0 512 512"
  }, props), /* @__PURE__ */React.createElement("path", {
    fill: "currentColor",
    d: "M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z"
  }));
};

TagCloseIcon.displayName = "TagCloseIcon";
var TagCloseButton = forwardRef(function (props, ref) {
  var isDisabled = props.isDisabled,
      children = props.children,
      rest = _objectWithoutProperties(props, _excluded);

  var styles = useTagStyles();

  var btnStyles = _objectSpread({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    outline: "0"
  }, styles.closeButton);

  return /* @__PURE__ */React.createElement(chakra.button, _objectSpread(_objectSpread({
    ref: ref,
    "aria-label": "close"
  }, rest), {}, {
    type: "button",
    disabled: isDisabled,
    __css: btnStyles
  }), children || /* @__PURE__ */React.createElement(TagCloseIcon, null));
});
TagCloseButton.displayName = "TagCloseButton";
export { Tag, TagCloseButton, TagLabel, TagLeftIcon, TagRightIcon, useTagStyles };